// Framework-agnostic slot/date formatting for the booking flow.
/** Calendar date (YYYY-MM-DD) for `d` in the given IANA timeZone. */
export function localCalendarDate(d, timeZone) {
    // en-CA formats as YYYY-MM-DD; timeZone shifts to the visitor's local day.
    return new Intl.DateTimeFormat("en-CA", {
        timeZone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
    }).format(d);
}
/** Format a YYYY-MM-DD date string into a readable day header like "Tue, Jun 10". */
export function formatDayHeader(dateStr) {
    // Parse as local date at noon to avoid timezone-offset day-shift.
    const [year, month, day] = dateStr.split("-").map(Number);
    const d = new Date(year, month - 1, day, 12, 0, 0);
    return d.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
    });
}
/**
 * Format an ISO datetime into a TTS-friendly slot label (e.g.
 * "Tue, Jun 9 at 1:30 PM"). Spoken verbatim by the agent, so it must never
 * be the raw ISO string.
 */
export function formatSlotLabel(isoStr) {
    const d = new Date(isoStr);
    const datePart = d.toLocaleDateString(undefined, {
        weekday: "short",
        month: "short",
        day: "numeric",
    });
    const timePart = d.toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });
    return `${datePart} at ${timePart}`;
}
/** Format just the time part of an ISO string for a slot button. */
export function formatSlotTime(isoStr) {
    return new Date(isoStr).toLocaleTimeString(undefined, {
        hour: "numeric",
        minute: "2-digit",
    });
}
